import { useLocationHash } from './useLocationParam';
import { getDecodedHashParams } from '../utils/hashUtils';
import { isNil } from '../utils/isNil';

const useHashParamsState = () => {
  const [hash, setHash] = useLocationHash();

  const updateHashParams = (params: Record<string, string | number | undefined>) => {
    const decodedHash = getDecodedHashParams(hash);

    Object.entries(params)
      .filter(([, value]) => !isNil(value))
      .forEach(([key, value]) =>
        decodedHash.set(key, encodeURIComponent((typeof value === 'number' ? value.toString() : value) as string)),
      );

    setHash(decodedHash.toString());
  };

  return { updateHashParams, hash };
};

export default useHashParamsState;
